import { render, staticRenderFns } from "./TradingOpenOrdersItems.vue?vue&type=template&id=a7e1db92&scoped=true&"
import script from "./TradingOpenOrdersItems.vue?vue&type=script&lang=js&"
export * from "./TradingOpenOrdersItems.vue?vue&type=script&lang=js&"
import style0 from "./TradingOpenOrdersItems.vue?vue&type=style&index=0&id=a7e1db92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e1db92",
  null
  
)

export default component.exports